import { render, staticRenderFns } from "./noticelist.vue?vue&type=template&id=2200e3d8&"
import script from "./noticelist.vue?vue&type=script&lang=js&"
export * from "./noticelist.vue?vue&type=script&lang=js&"
import style0 from "./noticelist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports